module.exports = __webpack_public_path__ + "img/xq.b6a2df95.svg";